import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';

import {ModalConfirmationComponent} from 'shared/modals/modal-confirmation/modal-confirmation.component';
import {CModule} from 'shared/models/cmodules/cmodule';
import {CModuleType} from 'shared/models/cmodules/cmodule-type';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';
import {CModulesOverviewService} from './services/cmodules-overview.service';
import {CModulesDetailsService} from '../cmodules-details/services/cmodules-details.service';
import * as Showdown from 'showdown';

@Component({
  selector: 'cmodules-overview',
  templateUrl: './cmodules-overview.component.html',
  styleUrls: ['./cmodules-overview.component.css'],
})
export class CModulesOverviewComponent implements OnInit {

  public activeStatus: 'all' | 'active' | 'inactive' = 'all';
  private cmodules: Array<CModule> = [];
  public filteredCModules: Array<CModule> = [];
  public fieldsToSearch: Array<Array<string>> = [];
  public currentPage: Event;
  public converter: Showdown.Converter = new Showdown.Converter();
  private maxHeightControl: Array<boolean> = [];

  @ViewChild('deleteModal') private deleteModal: ModalConfirmationComponent;

  constructor(private cmodulesOverviewService: CModulesOverviewService,
    private cmodulesDetailsService: CModulesDetailsService,
    private router: Router) {

    this.cmodules = [];
  }

  public ngOnInit(): void {
    this.cmodulesOverviewService.getCModules()
      .subscribe((cmodules: Array<CModule>) => {
        this.cmodules = cmodules;
        this.filteredCModules = cmodules;
        this.prepareFieldsToSearch();
        this.maxHeightControl.length = this.cmodules.length;
      });
  }

  public editCModule(id: string): void {
    this.router.navigate(['cmodules', 'details', {cmoduleId: id}]);
  }

  public createCModule(): void {
    //this.router.navigateByUrl('cmodules/details');
    this.router.navigate(['cmodules', 'details', {orderno: this.cmodules.length+1}]);
  }

  public deleteCModule(id: string): void {
    this.cmodulesOverviewService.deleteCModule(id)
      .subscribe(() => {
        const index: number = this.cmodules.findIndex((cmodule: CModule) => {
          return cmodule._id === id;
        });

        if (index > -1) {
          this.cmodules.splice(index, 1);
        }
      });
  }

  public showDeleteModal(id: string): void {
    const cmoduleName: string = this.getCModuleById(id).title.de;
    const cmodule: string = `Sind Sie sicher, dass Sie das Modul "${cmoduleName}" löschen möchten?`;

    this.deleteModal.setContent(cmodule)
      .setEventData(id)
      .show();
  }

  public get filteredCModulesByActiveStatus(): Array<CModule> {
    return this.cmodules.filter((cmodule) => {
      return this.filterByActiveStatus(cmodule);
    });
  }

  public filterCModules(eventCModules: Array<CModule>): void {
    this.filteredCModules = eventCModules;
  }

  public prepareFieldsToSearch(): void {
    this.fieldsToSearch = [];
    this.filteredCModulesByActiveStatus.forEach((cmodule) => {
      this.fieldsToSearch.push([
        cmodule.description.de.toLowerCase(),
        cmodule.title.de.toLowerCase(),
      ]);
    });
  }

  private filterByActiveStatus(cmodule: CModule): boolean {
    if (this.activeStatus === 'all') {
      return true;
    }

    const active: boolean = this.activeStatus === 'active';
    return cmodule.active === active;
  }

  private getCModuleById(id: string): CModule {
    return this.cmodules.find((cmodule: CModule) => {
      return cmodule._id === id;
    });
  }

  public getTargetGroups(cmodule:CModule): string {
    if (cmodule.omnibus) {
      return 'Für alle';
    }
    const sFree = cmodule.targetGroups ? cmodule.targetGroups.map(group => group.title).join(', ') : '';
    const sPurchase = cmodule.targetGroupsPurchasable ? cmodule.targetGroupsPurchasable.map(group => '<i class="fa fa-fw fa-shopping-cart"></i> ' + group.title).join(', ') : '';
    return sFree + (sFree != '' && sPurchase != '' ? '<br>' : '') + sPurchase;
  }

  public getActiveIcon(cmodule: CModule): string { // tslint:disable-line
    return cmodule.active ? 'glyphicon-ok' : 'glyphicon-remove';
  }

  public getActiveClass(cmodule: CModule): string { // tslint:disable-line
    return cmodule.active ? 'no-button-success' : 'no-button-danger';
  }

  public isFirstCModule(cmodule: CModule): boolean {
    return cmodule.orderno == 1;
  }

  public isLastCModule(cmodule: CModule): boolean {
    return cmodule.orderno == this.cmodules.length;
  }

  public getMaxHeight(id: number): string {
    if (this.maxHeightControl[id]) {
      return '300px';
    } else {
      return '85px';
    }
  }

  public toggleMaxHeight(id: number): void {
    if (!this.maxHeightControl[id]) {
      this.maxHeightControl[id] = true;
      return;
    }
    this.maxHeightControl[id] = false;
  }

  public changeSort(cmodule1: CModule, dir: number) {
    const cmodule2 = this.cmodules.find((cmodule: CModule) => { return cmodule.orderno == cmodule1.orderno+dir; });
    cmodule1.orderno += dir;
    cmodule2.orderno -= dir;
    this.cmodulesDetailsService.updateCModule(cmodule1)
      .subscribe((cmodule: CModule) => {
        this.cmodulesDetailsService.updateCModule(cmodule2)
         .subscribe((cmodule: CModule) => {
           this.cmodules = this.cmodules.sort((b1, b2) => {
             return b1.orderno < b2.orderno ? -1 : 1;
           });
           this.cmodules = [...this.cmodules];
         });
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/cmodules/cmodules-overview/cmodules-overview.component.ts